/**
 * Read-only email display helpers.
 * System placeholder addresses (`*@placeholder.local`) must never appear as technical strings in UI.
 */

function isPlaceholderEmail(email) {
  const s = email != null ? String(email).trim().toLowerCase() : "";
  return !!(s && s.endsWith("@placeholder.local"));
}

/**
 * Trimmed email for summaries/tables, or em dash when empty or placeholder.
 */
function displayEmailOrDash(email) {
  const s = email != null ? String(email).trim() : "";
  if (!s || isPlaceholderEmail(s)) return "—";
  return s;
}

module.exports = { isPlaceholderEmail, displayEmailOrDash };
